export default __webpack_public_path__ + "static/Blind-angels-kayla-video-thumbnail-a2513cc75f4a523e7bbb3571d5a8fdb9.png";